import { render, staticRenderFns } from "./WebSetting.vue?vue&type=template&id=3b43e72b&scoped=true&"
import script from "./WebSetting.vue?vue&type=script&lang=js&"
export * from "./WebSetting.vue?vue&type=script&lang=js&"
import style0 from "./WebSetting.vue?vue&type=style&index=0&id=3b43e72b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b43e72b",
  null
  
)

export default component.exports